var _a;
import { Ticket_State_Priority } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Ticket_State_Priority.ClosedReadyToClose] = 'Ready to close',
    _a[Ticket_State_Priority.ClosedResolved] = 'Closed',
    _a[Ticket_State_Priority.ClosedUnresolved] = 'Closed (Unresolved)',
    _a[Ticket_State_Priority.InProgressNavigator] = 'In Progress Navigator',
    _a[Ticket_State_Priority.InProgressWaiting] = 'In Progress Waiting',
    _a[Ticket_State_Priority.PendingAssigned] = 'Assigned',
    _a[Ticket_State_Priority.PendingNew] = 'New',
    _a[Ticket_State_Priority.PendingWaiting] = 'Waiting For Assignment',
    _a);
export var TicketStatePriorityEnum = {
    name: 'Ticket_State_Priority',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
